import {
  red,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
  brown,
  grey,
  blueGrey
} from '@mui/material/colors';

export const createGenericColorMap = <T, U>(list: T[], idGetter: (item: T) => U) => {
  const colors: string[] = [];

  const variations = [400, 900, 100, 700, 300, 800, 200, 600, 500];
  const baseColors = [
    blue,
    red,
    green,
    yellow,
    orange,
    grey,
    brown,
    pink,
    purple,
    lightBlue,
    lightGreen,
    cyan,
    indigo,
    teal,
    lime,
    deepPurple,
    amber,
    deepOrange,
    blueGrey
  ];

  variations.forEach(variation => {
    baseColors.forEach(base => {
      const color = base[variation as keyof typeof base];
      if (color) colors.push(color);
    });
  });

  const getColorById = (id: U): string => {
    const index = list.findIndex(item => idGetter(item) === id);
    return colors[index % colors.length] ?? '';
  };

  const getColorByItem = (item: T): string => getColorById(idGetter(item));

  return {
    getColorById,
    getColorByItem
  };
};
